module.exports = __webpack_public_path__ + "static/media/b0_p15_clickable_b.be81eeb0.mp3";